let setClerks = (state, clerksDto) => {
	state.clerks = clerksDto;
};

export default { setClerks, };
